<template>
  <div class="row help-wrapper">
    <!-- <header-about /> -->
    <div id="corpo" class="col s12 m8 mensagem-about-geral">
      <h5 class="center">
        Contato
      </h5>
      <div v-if="censo_domain_esp">
        <div id="corpo" class="col">
          <p v-html="entidade_contato.contato_description"></p>
          <li v-if="chatOption" class="row s2"><i class="material-icons">chat</i><span v-html="meta.contatos_censo.chat"></span></li>
          <template v-for="(numero, index) in entidade_contato.números">
            <li v-bind:key="index" class="row s2">
              <i v-if="entidade_contato.números[index].telefone" class="material-icons mdi mdi-phone"></i>
              <i v-if="entidade_contato.números[index].whatsapp" class="material-icons mdi mdi-whatsapp"></i>
            <span v-html="entidade_contato.números[index].numero"></span></li>
          </template>
        </div>
      </div>
      <div v-else>
        <div class="input-field col s12" v-if="showMunicipioSelect === true">
          <select v-model="selectedMunicipio" @change="handlerChange">
            <option :value="null" disabled selected>Selecione Municipio ou Estado</option>
            <option v-for="(municipio, i) in meta.censo_domain" v-bind:key="i" v-bind:value="i">{{ municipio.nome }}</option>
          </select>
        </div>
        <template v-if="selectedMunicipio !== null ">
          <p v-html="meta.censo_domain[selectedMunicipio].contato.contato_description"></p>
          <ul class="lista-documentos">
            <li v-if="chatOption"><i class="material-icons">chat</i><span v-html="meta.contatos_censo.chat"></span></li>
            <template v-for="(numero, index) in meta.censo_domain[selectedMunicipio].contato.números">
              <li v-bind:key="index">
                <i v-if="meta.censo_domain[selectedMunicipio].contato.números[index].telefone" class="material-icons mdi mdi-phone"></i>
                <i v-if="meta.censo_domain[selectedMunicipio].contato.números[index].whatsapp" class="material-icons mdi mdi-whatsapp"></i>
              <span v-html="meta.censo_domain[selectedMunicipio].contato.números[index].numero"></span></li>
            </template>
          </ul>
          <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s8" id="abouBtnLogin">
            Voltar
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import HeaderAbout from "@/components/HeaderAbout.vue"

import {formataData, converteTimestamp, converteData, converteDataHora} from '@/assets/js/form-utils.js'
import SocialService from '@/services/social-service.js'
import {CONFIG} from '@/config/config.js'
import MunicipioSeletor from '../mixins/municipioSeletor'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Info',
  mixins: [MunicipioSeletor],
  components: {
    loading: Loading,
    "header-about": HeaderAbout
  },
  data (){
    return {
      meta: this.$store.state.meta.data,
      last_page: this.$store.state.route.from.fullPath,
      action: (this.$route.params.action ? this.$route.params.action : null),
      selectedMunicipio: null,
      showMunicipioSelect: true,
      censo_domain_esp: false,
      domain_name: '',
      entidade_contato: '',
      chatOption: false
    }
  },
  methods: {
    isEspecial() {
      if(this.$store.state.meta.data.host){
        return true;
      }
      return false;
    },
    toggleChatWidget(op){
      if (op){
        window.renderBotWidget(
          '658c0fa8199960688d44041a',
          { // Objeto com variáveis e configurações de layout do webchat.
            var_title: "var_value", // Variável da sessão.
            layout: { //Caso exista o objeto layout, este será utilizado para definir configurações do webchat.
            // 'bot-name': 'Teste título', // Nome do bot
            // 'bot-bg-color': '278222', // Cor de fundo da mensagem do bot.
            // 'bot-text-color': 'fff', // Cor do texto da mensagem do bot.
            // 'user-bg-color': '6a5837', // Cor de fundo da mensagem do usuário e do título do chat.
            // 'user-text-color': 'fff0f0', // Cor do texto da mensagem do usuário e do título do chat.
          }
        },
        false, // Define se é para reiniciar a sessão caso os parâmetros sejam alterados.
        false, // Define um id customizado para o elemento que vai renderizar o webchat no html.
        );
      }
    },
    handlerChange(){
      if(this.selectedMunicipio !== null) {
        localStorage.setItem('selectedMunicipio', this.selectedMunicipio);
        this.liveChatOption();
      }
    },
    liveChatOption() {
      const meta_data = this.$store.state.meta.data;
      const liveChat = this.isEspecial() == true ?
        meta_data.censo_domain_esp[meta_data.host] :
        meta_data.censo_domain[this.selectedMunicipio];
      
      if (liveChat && liveChat.contato.live_chat == false) {
        this.chatOption = false;
        this.toggleChatWidget(false);
        if(document.querySelector("#boteria_webchat")){
          document.querySelector("#boteria_webchat").remove()
        }
      } else {
        this.chatOption = true;
        this.toggleChatWidget(true);
      }
    },
    setup_domain() {
      const meta_data = this.$store.state.meta.data;
      const selectedMunicipio = localStorage.getItem("selectedMunicipio");

      if (this.isEspecial()) {
        this.liveChatOption();
        this.censo_domain_esp = true;
        this.domain_name = meta_data.censo_domain_esp[meta_data.host].nome || "";
        this.entidade_contato = meta_data.censo_domain_esp[meta_data.host].contato || "";
        this.entidade_banner = meta_data.censo_domain_banner;
      } else {
        if(selectedMunicipio){
          this.selectedMunicipio = selectedMunicipio;
          this.liveChatOption();
        } else {
          this.chatOption = false;
        }
      }
    },
  },
  mounted(){
    this.setup_domain()
    this.municipioSeletor()
    setTimeout(() => M.FormSelect.init(document.querySelectorAll('select')), 100)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Contato.vue